import React, { Component } from 'react';
import { connect } from 'react-redux';
import handleViewport from 'react-in-viewport';
import cx from 'classnames';

import { ITEM_SUBTYPES, ITEM_TYPES } from '../types/objectTypes';
import { onPageEndReached } from '../../store/actions/activeProject/survey';
import { shouldRenderMobile } from '../../utils/platform';

import styles from './endOfPage.module.scss';

interface IEndOfPageState {
  apply: boolean;
}

interface IMapStateToProps {
  sectionVisible: boolean;
}

interface IDispatchToProps {
  onPageEndReached: typeof onPageEndReached;
}

type Props = IMapStateToProps & IDispatchToProps & handleViewport.InjectedViewportProps<HTMLDivElement>;
//Component to check if respondent has reached the end of the page
class EndOfPageBase extends Component<Props, IEndOfPageState> {
  private endOfPageRef;
  private timeoutId;

  constructor(props) {
    super(props);
    this.state = {
      apply: false,
    };
    this.timeoutId = null;
    this.setApply = this.setApply.bind(this);
    this.endOfPageRef = React.createRef();
  }

  componentDidMount(): void {
    const { apply } = this.state;
    const { inViewport, enterCount, onPageEndReached, sectionVisible } = this.props;
    const elementRef = this.endOfPageRef.current;

    if (elementRef && inViewport && enterCount >= 1 && sectionVisible && apply) {
      onPageEndReached();
      elementRef.scrollIntoView({ behavior: 'smooth' });
    }
    if (inViewport && enterCount >= 1 && sectionVisible && !apply) {
      this.timeoutId = setTimeout(this.setApply, 200);
    }
  }

  componentDidUpdate() {
    const { apply } = this.state;
    const { inViewport, enterCount, onPageEndReached, sectionVisible } = this.props;
    const elementRef = this.endOfPageRef.current;

    if (elementRef && inViewport && enterCount >= 1 && sectionVisible && apply) {
      onPageEndReached();
      elementRef.scrollIntoView({ behavior: 'smooth' });
    }
    if (inViewport && enterCount >= 1 && sectionVisible && !apply) {
      this.timeoutId = setTimeout(this.setApply, 200);
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private setApply() {
    this.setState({ apply: true });
  }

  render() {
    const isMobile = shouldRenderMobile();
    return (
      <div
        ref={this.props.forwardedRef}
        className={cx(styles.endOfPage, {
          [styles.mobile]: isMobile,
        })}
      >
        <div ref={this.endOfPageRef} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { activeProject: { questionVisible = {}, survey = {}, pages = [], items = {} } = {} } = state;
  const { pageToShow } = survey;

  const currentPageObj = pages[pageToShow] || {};
  const firstItemId = currentPageObj.items && currentPageObj.items[0] ? currentPageObj.items[0] : null;
  const firstItem = items[firstItemId] || {};
  let sectionVisible = true;
  if (
    (firstItem.type === ITEM_TYPES.decorator &&
      [ITEM_SUBTYPES.link, ITEM_SUBTYPES.conceptTest].includes(firstItem.subtype)) ||
    firstItem.type === ITEM_TYPES.heatmap
  ) {
    sectionVisible = sectionVisible && questionVisible[firstItem.pageFrontendId];
  }

  return {
    sectionVisible,
  };
};

const mapDispatchToProps = {
  onPageEndReached,
};

const ConnectedEndOfPage = connect(mapStateToProps, mapDispatchToProps)(EndOfPageBase);

export const EndOfPage = handleViewport(ConnectedEndOfPage, {
  threshold: 0.5,
});
